var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "slot" } },
    [
      _c("c-header-return", { attrs: { title: "★ POGGI" } }),
      _c(
        "div",
        {
          ref: "gameWindow",
          staticClass:
            "game-window tw-size-full tw-relative tw-rounded-xl tw-overflow-hidden",
        },
        [
          _c(
            "div",
            { staticClass: "float-back-btn", on: { click: _vm.goBack } },
            [_vm._v("返回")]
          ),
          !!_vm.user.nickname
            ? [
                _c("iframe", {
                  ref: "gameIframe",
                  staticClass: "game-frame tw-size-full tw-rounded-xl",
                  attrs: {
                    allowfullscreen: "",
                    name: "poggi",
                    allow: "autoplay",
                    width: "100%",
                    scrolling: "no",
                    frameborder: "0",
                  },
                  on: { load: _vm.initGameMessager },
                }),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "tw-size-full tw-rounded-xl not-login" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "submit-button",
                        on: { click: _vm.setLogin },
                      },
                      [_vm._v("请先登录")]
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }